import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { NavLink } from 'react-router-dom'
import { isEmpty } from 'lodash'

import { logOutAndRedirect } from '../../utils/auth'
import { useMobileDetect } from '../../hooks/useMobileDetect'

import Dropdown from '../../components/Dropdown'
import IconAttendants from '../icons/IconAttendants'
import IconCustomers from '../icons/IconCustomers'
import IconDirectory from '../icons/IconDirectory'
import IconEvents from '../icons/IconEvents'
import LinkButton from '../../components/LinkButton'

const Sidebar = ({
  isOpen,
  selectVenue,
  signOut,
  toggleSidebarActive,
  userEmail,
  venues,
  currentVenue,
}) => {
  const { isMobile } = useMobileDetect()
  const handleLogOut = () => {
    signOut()
    logOutAndRedirect()
  }

  const handleVenueChange = event => {
    selectVenue(event.target.value)
  }

  return (
    <aside className={cn('sidebar', { '-open': isOpen })}>
      <div className="sidebar__wrapper">
        <header className="sidebar__header">
          <button className="sidebar__menu" type="button">
            <IconDirectory className="sidebar__menu-icon" />
          </button>
          <h3 className="sidebar__title">{currentVenue.label}</h3>
          {!isEmpty(venues) && (
            <Dropdown
              className="venue-select-dropdown"
              dark
              fullWidth
              isValid
              label="Current venue"
              onChange={handleVenueChange}
              options={venues}
              required
              value={currentVenue.value}
            />
          )}
        </header>
        <nav>
          <NavLink
            activeClassName="-active"
            className="sidebar__item"
            onClick={isMobile ? toggleSidebarActive : null}
            to="/events"
          >
            <IconEvents className="sidebar__menu-icon -navigation" />
            <span className="sidebar__menu-title">Events</span>
          </NavLink>
          <NavLink
            activeClassName="-active"
            className="sidebar__item"
            onClick={isMobile ? toggleSidebarActive : null}
            to="/customers"
          >
            <IconCustomers className="sidebar__menu-icon -navigation" />
            <span className="sidebar__menu-title">Customers</span>
          </NavLink>
          <NavLink
            activeClassName="-active"
            className="sidebar__item"
            onClick={isMobile ? toggleSidebarActive : null}
            to="/staff"
          >
            <IconAttendants className="sidebar__menu-icon -navigation" />
            <span className="sidebar__menu-title">Staff</span>
          </NavLink>
          <div className="sidebar__user">
            <div>
              <div className="sidebar__signed-info">{userEmail}</div>
              <LinkButton onClick={handleLogOut} title="Sign out" />
            </div>
          </div>
        </nav>
      </div>
      <div className="sidebar__overlay" onClick={toggleSidebarActive} />
    </aside>
  )
}

Sidebar.defaultProps = {
  toggleSidebarActive: () => {},
  userEmail: '',
  signOut: () => {},
}

Sidebar.propTypes = {
  isOpen: PropTypes.bool,
  toggleSidebarActive: PropTypes.func,
  userEmail: PropTypes.string,
  signOut: PropTypes.func,
}

export default Sidebar
